/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/cs.js'



import {Notify,Dialog,Meta} from 'quasar'



export default { config: {"brand":{"primary":"#B9CF38","secondary":"#1CACE4","dark-page":"#121212","positive":"#21BA45","negative":"#C10015","info":"#31CCEC","warning":"#F2C037","chart-secondary":"#EAF1C3"}},lang,plugins: {Notify,Dialog,Meta} }

